/** Canonical item policy shared by the client drop tables and catalog rules. */
export const DROP_ONLY_TM_TYPES = Object.freeze([
  'electric', 'fire', 'water', 'grass', 'bug', 'flying', 'normal', 'psychic', 'rock',
  'ground', 'ghost', 'dragon', 'fighting', 'poison', 'dark', 'steel', 'ice', 'fairy',
]);

export const DROP_ONLY_SLUGS = Object.freeze([
  'pheromone',
  ...DROP_ONLY_TM_TYPES.map((type) => `tm-${type}`),
]);

export const DROP_ONLY_SLUG_SET = new Set(DROP_ONLY_SLUGS);

export function isDropOnlySlug(slug) {
  return DROP_ONLY_SLUG_SET.has(String(slug || '').toLowerCase());
}

export function canonicalizeDropOnlyMap(raw) {
  const next = raw && typeof raw === 'object' ? { ...raw } : {};
  const legacyQty = Math.max(0, Math.floor(Number(next['strange-pheromone']) || 0));
  if (legacyQty > 0) next.pheromone = Math.max(0, Math.floor(Number(next.pheromone) || 0)) + legacyQty;
  delete next['strange-pheromone'];
  return next;
}
